/**
 *
 * Logo
 *
 */
import React from 'react';

import { Flex, FlexProps } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { CompanyLogoIcon } from 'components/Icons';

interface Props extends FlexProps {}

export const Logo: React.FC<Props> = props => {
  return (
    <Flex align="left" w="100px" {...props} py={4}>
      <Link to="/home">
        <CompanyLogoIcon />
      </Link>
    </Flex>
  );
};
